import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { TrustCard } from './ConsentComponents';

const SimpleLoginComponent = () => {
  const [error, setError] = useState('');
  
  // Detect language from browser
  const [lang, setLang] = useState('en');
  
  useEffect(() => {
    const browserLang = navigator.language?.split('-')[0] || 'en';
    setLang(browserLang === 'es' ? 'es' : 'en');
  }, []);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Redirect to the root of the app, the hash will contain the session_id
    const redirectUrl = window.location.origin;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-4">
      <div className="max-w-md w-full space-y-8">
        {/* Header with Logo */}
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_prospermind-charts/artifacts/bhqmeu3t_Logo%20ProsperMind.png" 
              alt="ProsperMind - Financial Health and Education Platform"
              title="ProsperMind - Financial Health and Education Platform"
              className="h-32 w-auto max-w-lg"
            />
          </div>
        </div>

        {/* Error Display */}
        {error && (
          <div className="bg-red-900/50 border border-red-500 rounded-lg p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-300">
                  {lang === 'es' ? 'Error de inicio de sesión' : 'Sign In Error'}
                </h3>
                <div className="mt-2 text-sm text-red-200">
                  <p>{error}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Login Card */}
        <Card className="shadow-lg border border-gray-800 bg-gray-900">
          <CardHeader>
            <CardTitle className="text-2xl text-center text-white">
              {lang === 'es' ? 'Iniciar Sesión' : 'Sign In'}
            </CardTitle>
            <CardDescription className="text-center text-gray-400">
              {lang === 'es' 
                ? 'Usa tu cuenta de Google para acceder' 
                : 'Use your Google account to sign in'}
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            {/* Google OAuth Button - Only login method */}
            <Button
              type="button"
              onClick={handleGoogleLogin}
              className="w-full bg-white hover:bg-gray-100 text-gray-900 font-medium py-4 flex items-center justify-center gap-3 text-lg"
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              {lang === 'es' ? 'Continuar con Google' : 'Continue with Google'}
            </Button>

            {/* Trust Card */}
            <TrustCard lang={lang} />
          </CardContent>
        </Card>

        {/* Footer */}
        <div className="text-center text-xs text-gray-500">
          <p>
            {lang === 'es' ? 'Al iniciar sesión, aceptas nuestros' : 'By signing in, you agree to our'}{' '}
            <Link to="/terms" className="text-yellow-500 hover:text-yellow-400">
              {lang === 'es' ? 'Términos de Servicio' : 'Terms of Service'}
            </Link>{' '}
            {lang === 'es' ? 'y' : 'and'}{' '}
            <Link to="/privacy" className="text-yellow-500 hover:text-yellow-400">
              {lang === 'es' ? 'Política de Privacidad' : 'Privacy Policy'}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SimpleLoginComponent;
